export default __webpack_public_path__ + "static/media/Leaders_Shapes-01.9c52d464.png";